var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5366",
    "data-name": "Group 5366",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.595,
    height: 35.306,
    viewBox: "0 0 45.595 35.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5365",
    "data-name": "Group 5365",
    transform: "translate(4.832 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M293.856,226.428l-.133-1.93a58.683,58.683,0,0,0,31.586-12.014l1.18,1.532a60.613,60.613,0,0,1-32.632,12.412Z",
    transform: "translate(-293.723 -212.485)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5366-2",
    "data-name": "Group 5366",
    transform: "translate(0.879 19.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M299.764,248.118a.97.97,0,0,1-.729-.331l-3.482-4-4.418,2.926a.967.967,0,0,1-1.492-.936l1.788-13.221,1.917.258-1.5,11.108,3.347-2.216a.969.969,0,0,1,1.262.171l2.638,3.026,1.5-11.109,1.916.258-1.789,13.222a.966.966,0,0,1-.682.8A.94.94,0,0,1,299.764,248.118Z",
    transform: "translate(-289.635 -232.561)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5367",
    "data-name": "Group 5367",
    transform: "translate(16.845 20.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M308.37,248.479a.969.969,0,0,1-.962-.875l-1.26-13.283,1.925-.183,1.058,11.16,2.532-2.68a1.351,1.351,0,0,1,1.757-.168l2.992,2.158-1.058-11.159,1.924-.183,1.259,13.282a.966.966,0,0,1-1.528.875l-4.3-3.1-3.64,3.853A.967.967,0,0,1,308.37,248.479Z",
    transform: "translate(-306.148 -233.266)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5368",
    "data-name": "Group 5368",
    transform: "translate(30.675 15.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M325.645,245.7c-.031,0-.063,0-.1-.005a.967.967,0,0,1-.82-.652l-4.279-12.638,1.832-.619,3.594,10.617,2.013-3.474a.967.967,0,0,1,1.207-.409l3.708,1.536-3.595-10.616,1.831-.62,4.278,12.637a.967.967,0,0,1-1.286,1.2l-4.894-2.029-2.658,4.586A.964.964,0,0,1,325.645,245.7Z",
    transform: "translate(-320.451 -228.822)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5369",
    "data-name": "Group 5369",
    transform: "translate(10.583 4.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M300.954,230.412l-1.283-4.691,1.866-.511,1.283,4.692Zm8.735-.243-2.549-6.505,1.8-.7,2.549,6.506Zm6.758-1.3-3.609-7.648,1.749-.825,3.607,7.648Zm7.963-2.086-4.475-8.932,1.73-.867,4.475,8.933Z",
    transform: "translate(-299.671 -216.984)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5370",
    "data-name": "Group 5370",
    transform: "translate(0 13.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M305.028,234.871a60.338,60.338,0,0,1-16.3-2.232l.521-1.861A58.547,58.547,0,0,0,332,226.341l.895,1.714A60.391,60.391,0,0,1,305.028,234.871Z",
    transform: "translate(-288.726 -226.341)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.d2de18ca8d59d7b353b1789bfefa437c.svg";
export { ForwardRef as ReactComponent };